import React, { createContext, useEffect, useState } from 'react';
import { Button, Col, Input, Popover, Radio, Row, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import LoanTabDatas from './LoanTabDatas';
import '../../assets/css/custom.css';
import SwitchBox from './SwitchBox';
import SortBy from './SortBy';
import CaseTabDetails from './CaseTabDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLoanApplicationDetailsFilter } from '../../redux/slice/dealerCommFilterSlice';
export const CaseDataContext = createContext(null);
const CaseDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loanAppfilters = useSelector(
    (state) => state.dealerCommFilter?.loanAppDetailsFilter
  );
  const [formType, setFormType] = useState('loan');
  const [caseDetails, setCaseDetails] = useState({});
  const isDisbursed = caseDetails?.disbursementinfo !== null && caseDetails?.disbursementinfo !== undefined ? true : false
  const [activeTab, setActiveTab] = useState(
    loanAppfilters?.activeTab !== undefined && loanAppfilters?.activeTab !== ''
      ? loanAppfilters?.activeTab
      : isDisbursed ? "2" : '1'
  );
  const applicationId = location.state?.Id;
  const pagePermission = location.state?.pagePermission;
  // console.log('PAGE PERMISSOn', pagePermission);
  useEffect(() => {
    if (applicationId !== null && applicationId !== undefined) {
      localStorage.setItem('applicationId', applicationId);
    }
  }, [applicationId]);
  const [activeKey, setActiveKey] = useState('1');
  const onChange = (tabValue) => {
    if (tabValue == '1') {
      setFormType('loan');
    } else if (tabValue == '2') {
      setFormType('vehicle');
    } else if (tabValue == '3') {
      setFormType('applicant');
    } else if (tabValue == '4') {
      setFormType('guarantor');
    } else if (tabValue == '5') {
      setFormType('disbursement');
    }
    //else if (tabValue == '6') {
    //   setFormType('disbursement');
    // }
    setActiveKey(tabValue);
    localStorage.setItem('tabValue', tabValue);
  };

  const handleSortBy = (val) => {
    switch (val) {
      case 'Most Recent':
        break;
      case 'Name A-Z':
        break;
      case 'Name Z-A':
        break;
      default:
        break;
    }
  };

  const items = [
    {
      label: 'Application Details',
      key: '1',
      children: '',
    },
    {
      label: 'Vehicle Details',
      key: '2',
      children: '',
    },
    {
      label: 'Applicant Details',
      key: '3',
      children: '',
    },
    {
      label: 'Guarantors',
      key: '4',
      children: '',
    },
    // {
    //   label: 'Dealer Details',
    //   key: '5',
    //   children: '',
    // },
    {
      label: 'Disbursement',
      key: '5',
      children: '',
    },
  ];

  const applicationDetails = async () => {
    const response = await ServerAPI.applicationInfo();

    // console.log("detAAISSSSSSSSSSS",response)
    if (response.data) {
      const settings = await ServerAPI.settingsData();
      if (settings.data) {
        let applicantType = settings.data.loanApplicantTypes.filter(
          (type) => type.id == response.data
        );
      }
      const respData = response.data;
      setCaseDetails(response.data);
      localStorage.setItem('applicationno', respData?.id);
      if (respData?.vehicle_details) {
        const vehData = respData?.vehicle_details;
        if (respData?.category == 'f96b81ae-7210-4332-80d2-070556ea724b') {
          let localData = {
            vehicle_reg_no: {
              value: vehData.vehicle_reg_no,
              validation: true,
            },
            customer_id_type: {
              value: vehData.customer_id_type,
              validation: true,
            },
            owner_id: {
              value: vehData.owner_id,
              validation: true,
            },
            make_model: {
              value: vehData.make_model,
              validation: true,
            },
            opc_vehicle_id: {
              value: vehData.opc_vehicle_id,
              validation: true,
            },
            is_opc_car: {
              value: vehData.is_opc_car,
              validation: true,
            },
            vehicle_under_opc: {
              value: Number(vehData.vehicle_under_opc),
              validation: true,
            },
            vehicle_emission_scheme: {
              value: vehData.vehicle_emission_scheme,
              validation: true,
            },
            vehicle_coe_category: {
              value: vehData.vehicle_coe_category,
              validation: true,
            },
            vehicle_coe_amount: {
              value: vehData.vehicle_coe_amount,
              validation: true,
            },
            vehicle_ori_reg_date: {
              value: vehData.vehicle_ori_reg_date,
              validation: true,
            },
            vehicle_chassis_no: {
              value: vehData.vehicle_chassis_no,
              validation: true,
            },
            vehicle_engine_no: {
              value: vehData.vehicle_engine_no,
              validation: true,
            },
            vehicle_omv: {
              value: vehData.vehicle_omv,
              validation: true,
            },
            vehicle_purchase_price: {
              value: vehData.vehicle_purchase_price,
              validation: true,
            },
            vehicle_yom: {
              value: vehData.vehicle_yom,
              validation: true,
            },
          };
          let localDataDoc = {
            sale_agreement: vehData.sale_agreement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: vehData.additional_documents.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            vehicle_overseas_log_card: vehData.vehicle_overseas_log_card.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            data_card: vehData.data_card.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            cargo_clearance_permits: vehData.cargo_clearance_permits.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            bill_of_lading: vehData.bill_of_lading.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            letter_of_newness: vehData.letter_of_newness.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
          };
          localStorage.setItem('vehicleDetails', JSON.stringify(localData));
          localStorage.setItem(
            'vehicleDocuments',
            JSON.stringify(localDataDoc)
          );
        } else {
          let localData = {
            vehicle_reg_no: {
              value: vehData.vehicle_reg_no,
              validation: true,
            },
            customer_id_type: {
              value: vehData.customer_id_type,
              validation: true,
            },
            owner_id: {
              value: vehData.owner_id,
              validation: true,
            },
            make_model: {
              value: vehData.make_model,
              validation: true,
            },
            opc_vehicle_id: {
              value: vehData.opc_vehicle_id,
              validation: true,
            },
            is_opc_car: {
              value: vehData.is_opc_car,
              validation: true,
            },
          };
          let localDataDoc = {
            log_card: vehData?.log_card.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            sale_agreement: vehData.sale_agreement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: vehData.additional_documents.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
          };
          localStorage.setItem('vehicleDetails', JSON.stringify(localData));
          localStorage.setItem(
            'vehicleDocuments',
            JSON.stringify(localDataDoc)
          );
        }
      }
      if (respData?.applicant_details) {
        localStorage.setItem(
          'applicanttypeid',
          respData?.applicant_details?.applicant_type
        );
        localStorage.setItem(
          'applicanttype',
          respData?.applicant_details?.typeinfo?.applicant_type
        );
      }
      if (
        respData?.applicant_details !== null && respData?.applicant_details !== undefined
      ) {
        const applType = respData?.applicant_details?.typeinfo?.applicant_type;
        const applData = respData?.applicant_details;

        // console.log('applType', applType);
        if (
          applType == 'Singapore Citizen' ||
          applType == 'Permenant Resident(PR)'
        ) {
          let localData = {
            title: {
              value: applData.title,
              validation: true,
            },
            name: {
              value: applData.name,
              validation: true,
            },
            nric: {
              value: applData.nric,
              validation: true,
            },
            dob: {
              value: applData.dob,
              validation: true,
            },
            gender: {
              value: applData.gender,
              validation: true,
            },
            race: {
              value: applData.race,
              validation: true,
            },
            name_of_spouse: {
              value: applData.name_of_spouse,
              validation: true,
            },
            home_no: {
              value: applData.home_no,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            marital_status: {
              value: applData.marital_status,
              validation: true,
            },
            residence_type: {
              value: applData.residence_type,
              validation: true,
            },
            home_address: {
              value: applData.home_address,
              validation: true,
            },
            postal_code: {
              value: applData.postal_code,
              validation: true,
            },
            home_address_same_as_mailing: {
              value: applData.home_address_same_as_mailing,
              validation: true,
            },
            mailing_residence_type: {
              value: applData.mailing_residence_type,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_home_address: {
              value: applData.mailing_home_address,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_postal_code: {
              value: applData.mailing_postal_code,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
          };
          localStorage.setItem('applicant_details', JSON.stringify(localData));
        } else if (applType == 'Work Pass Holder(FIN)') {
          let localData = {
            title: {
              value: applData.title,
              validation: true,
            },
            name: {
              value: applData.name,
              validation: true,
            },
            dob: {
              value: applData.dob,
              validation: true,
            },
            gender: {
              value: applData.gender,
              validation: true,
            },
            race: {
              value: applData.race,
              validation: true,
            },
            name_of_spouse: {
              value: applData.name_of_spouse,
              validation: true,
            },
            home_no: {
              value: applData.home_no,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            marital_status: {
              value: applData.marital_status,
              validation: true,
            },
            residence_type: {
              value: applData.residence_type,
              validation: true,
            },
            home_address: {
              value: applData.home_address,
              validation: true,
            },
            postal_code: {
              value: applData.postal_code,
              validation: true,
            },
            home_address_same_as_mailing: {
              value: applData.home_address_same_as_mailing,
              validation: true,
            },
            mailing_residence_type: {
              value: applData.mailing_residence_type,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_home_address: {
              value: applData.mailing_home_address,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_postal_code: {
              value: applData.mailing_postal_code,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            passport_expiry_date: {
              value: applData.passport_expiry_date,
              validation: true,
            },
            fin_no: {
              value: applData.fin_no,
              validation: true,
            },
            nationality: {
              value: applData.nationality,
              validation: true,
            },
          };
          localStorage.setItem('applicant_details', JSON.stringify(localData));
        } else if (applType == 'Foreign Work Pass(Passport)') {
          let localData = {
            title: {
              value: applData.title,
              validation: true,
            },
            name: {
              value: applData.name,
              validation: true,
            },
            dob: {
              value: applData.dob,
              validation: true,
            },
            gender: {
              value: applData.gender,
              validation: true,
            },
            race: {
              value: applData.race,
              validation: true,
            },
            name_of_spouse: {
              value: applData.name_of_spouse,
              validation: true,
            },
            home_no: {
              value: applData.home_no,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            marital_status: {
              value: applData.marital_status,
              validation: true,
            },
            residence_type: {
              value: applData.residence_type,
              validation: true,
            },
            home_address: {
              value: applData.home_address,
              validation: true,
            },
            postal_code: {
              value: applData.postal_code,
              validation: true,
            },
            home_address_same_as_mailing: {
              value: applData.home_address_same_as_mailing,
              validation: true,
            },
            mailing_residence_type: {
              value: applData.mailing_residence_type,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_home_address: {
              value: applData.mailing_home_address,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_postal_code: {
              value: applData.mailing_postal_code,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            passport_expiry_date: {
              value: applData.passport_expiry_date,
              validation: true,
            },
            passport_no: {
              value: applData.passport_no,
              validation: true,
            },
            nationality: {
              value: applData.nationality,
              validation: true,
            },
          };
          localStorage.setItem('applicant_details', JSON.stringify(localData));
        } else {
          let localData = {
            company_name: {
              value: applData.company_name,
              validation: true,
            },
            uen_acra_no: {
              value: applData.uen_acra_no,
              validation: true,
            },
            date_of_incorporation: {
              value: applData.date_of_incorporation,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            company_address: {
              value: applData.company_address,
              validation: true,
            },
            company_postal_code: {
              value: applData.company_postal_code,
              validation: true,
            },
            mailing_company_address: {
              value: applData.mailing_company_address,
              validation:
                applData.company_address_same_as_mailing == 0 ? false : true,
            },
            mailing_company_postal_code: {
              value: applData.mailing_company_postal_code,
              validation:
                applData.company_address_same_as_mailing == 0 ? false : true,
            },
            company_address_same_as_mailing: {
              value: applData.company_address_same_as_mailing,
              validation: true,
            },
          };
          localStorage.setItem('applicant_details', JSON.stringify(localData));
        }
      }
      if (respData?.applicant_employement_details) {
        const appEmpData = respData?.applicant_employement_details;
        const localData = {
          employment_type: {
            value: appEmpData.employment_type,
            validation: true,
          },
          occupation: {
            value: appEmpData.occupation,
            validation: true,
          },
          type_of_industry: {
            value: appEmpData.type_of_industry,
            validation: true,
          },
          service_duration_years: {
            value: appEmpData.service_duration_years,
            validation: true,
          },
          service_duration_months: {
            value: appEmpData.service_duration_months,
            validation: true,
          },
          monthly_income: {
            value: appEmpData.monthly_income,
            validation: true,
          },
          other_income: {
            value: appEmpData.other_income,
            validation: true,
          },
          finance_type: {
            value: appEmpData.finance_type,
            validation: true,
          },
          employer_name: {
            value: appEmpData.employer_name,
            validation: true,
          },
          employer_address: {
            value: appEmpData.employer_address,
            validation: true,
          },
          employer_postal_code: {
            value: appEmpData.employer_postal_code,
            validation: true,
          },
          employer_previous_occupation: {
            value: appEmpData.employer_previous_occupation,
            validation: true,
          },
          employer_previous_name: {
            value: appEmpData.employer_previous_name,
            validation: true,
          },
          employer_previous_experience_years: {
            value: appEmpData.employer_previous_experience_years,
            validation: true,
          },
          employer_previous_experience_months: {
            value: appEmpData.employer_previous_experience_months,
            validation: true,
          },
          employer_previous_address: {
            value: appEmpData.employer_previous_address,
            validation: true,
          },
          employer_previous_postal_code: {
            value: appEmpData.employer_previous_postal_code,
            validation: true,
          },
        };
        localStorage.setItem(
          'applicant_employement_details',
          JSON.stringify(localData)
        );
      }
      if (respData?.applicant_documents) {
        const applDocuments = respData?.applicant_documents;
        const applType = respData?.applicant_details?.typeinfo?.applicant_type;
        if (
          applType == 'Singapore Citizen' ||
          applType == 'Permenant Resident(PR)'
        ) {
          let localData = {
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            cpf: applDocuments.cpf.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            driving_license: applDocuments.driving_license.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            nao: applDocuments.nao.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            nric: applDocuments.nric.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            company_stamp: {
              name: 'companyStamp',
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: 'applicantSignature',
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            'applicant_documents',
            JSON.stringify(localData)
          );
        } else if (applType == 'Work Pass Holder(FIN)') {
          let localData = {
            work_permit: applDocuments.work_permit.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            pay_slip: applDocuments.pay_slip.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            driving_license: applDocuments.driving_license.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            nao: applDocuments.nao.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            appoinment_letter: applDocuments.appoinment_letter.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            company_stamp: {
              name: 'companyStamp',
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: 'applicantSignature',
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            'applicant_documents',
            JSON.stringify(localData)
          );
        } else if (applType == 'Foreign Work Pass(Passport)') {
          let localData = {
            passport: applDocuments.passport.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            bank_statement: applDocuments.bank_statement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            pay_slip: applDocuments.pay_slip.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            driving_license: applDocuments.driving_license.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            employment_letter: applDocuments.employment_letter.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            company_stamp: {
              name: 'companyStamp',
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: 'applicantSignature',
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            'applicant_documents',
            JSON.stringify(localData)
          );
        } else {
          let localData = {
            company_acra: applDocuments.company_acra.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            balance_sheet: applDocuments.balance_sheet.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            p_l_document: applDocuments.p_l_document.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            bank_statement: applDocuments.bank_statement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            company_stamp: {
              name: 'companyStamp',
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: 'applicantSignature',
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            'applicant_documents',
            JSON.stringify(localData)
          );
        }
      }
      if (respData?.guarantorDetails) {
        const guarantorData = respData?.guarantorDetails;
        // console.log("guarantordata=========>>>", guarantorData)
        const guarantorLength = guarantorData.length;
        localStorage.setItem('guarantorcount', guarantorLength);
        guarantorData.map((gData, idx) => {
          const g_details = {
            guarantor_type: gData.guarantor_type,
            guarantor_citizenship_type: gData.guarantor_citizenship_type,
          };
          // console.log('guarantorData', gData.personal_details);

          localStorage.setItem(`guarantor_id_${idx + 1}`, gData.id);

          if (
            gData.guarantor_type === 'individual' &&
            gData.personal_details !== null &&
            gData.personal_details !== undefined
          ) {
            // Personal details
            const g_personal_details = {
              title: {
                value: gData.personal_details?.title ?? '',
                validation: gData.personal_details?.title && gData.personal_details?.title !== '' ? true : false,
              },
              name: { value: gData.personal_details?.name ?? '', validation: true },
              nric: { value: gData.personal_details?.nric ?? '', validation: true },
              dob: { value: gData.personal_details?.dob ?? '', validation: true },
              gender: { value: gData.personal_details?.gender ?? '', validation: true },
              race: { value: gData.personal_details?.race ?? '', validation: true },
              name_of_spouse: {
                value: gData.personal_details?.name_of_spouse ?? '',
                validation: true,
              },
              home_no: { value: gData.personal_details?.home_no ?? '', validation: true },
              mobile_no: {
                value: gData.personal_details?.mobile_no ?? '',
                validation: true,
              },
              office: { value: gData.personal_details?.office ?? '', validation: true },
              email: { value: gData.personal_details?.email ?? '', validation: true },
              marital_status: {
                value: gData.personal_details?.marital_status ?? '',
                validation: gData.personal_details?.marital_status && gData.personal_details?.marital_status !== '' ? true : false,
              },
              residence_type: {
                value: gData.personal_details?.residence_type ?? '',
                validation: gData.personal_details?.residence_type && gData.personal_details?.residence_type !== '' ? true : false,
              },
              home_address: {
                value: gData.personal_details?.home_address ?? '',
                validation: true,
              },
              postal_code: {
                value: gData.personal_details?.postal_code ?? '',
                validation: true,
              },
              home_address_same_as_mailing: {
                value: gData.personal_details?.home_address_same_as_mailing ?? 1,
                validation: true,
              },
              mailing_residence_type: {
                value: gData.personal_details?.mailing_residence_type ?? '',
                validation:
                  gData.personal_details?.home_address_same_as_mailing == 0 &&
                    gData.personal_details?.mailing_residence_type === ''
                    ? false
                    : true,
              },
              mailing_home_address: {
                value: gData.personal_details?.mailing_home_address ?? '',
                validation:
                  gData.personal_details?.home_address_same_as_mailing == 0 &&
                    gData.personal_details?.mailing_home_address === ''
                    ? false
                    : true,
              },
              mailing_postal_code: {
                value: gData.personal_details?.mailing_postal_code ?? '',
                validation:
                  gData.personal_details?.home_address_same_as_mailing == 0 &&
                    gData.personal_details?.mailing_postal_code === ''
                    ? false
                    : true,
              },
            };

            localStorage.setItem(
              `guarantor_personal_details_${idx + 1}`,
              JSON.stringify(g_personal_details)
            );

            // Documents
            const g_docs = {
              additional_documents: gData.documents?.additional_documents?.map((item) => ({
                name: item.name,
                value: item.value,
              })) ?? [],
              cpf: gData.documents?.cpf?.map((item) => ({
                name: item.name,
                value: item.value,
              })) ?? [],
              driving_license: gData.documents?.driving_license?.map((item) => ({
                name: item.name,
                value: item.value,
              })) ?? [],
              nao: gData.documents?.nao?.map((item) => ({
                name: item.name,
                value: item.value,
              })) ?? [],
              bank_statement: gData.documents?.bank_statement?.map((item) => ({
                name: item.name,
                value: item.value,
              })) ?? [],
              nric: gData.documents?.nric?.map((item) => ({
                name: item.name,
                value: item.value,
              })) ?? [],
            };

            localStorage.setItem(
              `guarantor_documents_${idx + 1}`,
              JSON.stringify(g_docs)
            );

            // Employment details (safe optional chaining)
            if (gData.employement_details) {
              const g_emp_details = {
                employment_type: {
                  value: gData.employement_details?.employment_type ?? '',
                  validation: gData.employement_details?.employment_type && gData.employement_details?.employment_type !== '' ? true : false,
                },
                occupation: {
                  value: gData.employement_details?.occupation ?? '',
                  validation: true,
                },
                type_of_industry: {
                  value: gData.employement_details?.type_of_industry ?? '',
                  validation: true,
                },
                service_duration_years: {
                  value: gData.employement_details?.service_duration_years ?? '',
                  validation: true,
                },
                service_duration_months: {
                  value: gData.employement_details?.service_duration_months ?? '',
                  validation: true,
                },
                monthly_income: {
                  value: gData.employement_details?.monthly_income ?? '',
                  validation: true,
                },
                other_income: {
                  value: gData.employement_details?.other_income ?? '',
                  validation: true,
                },
                finance_type: {
                  value: gData.employement_details?.finance_type ?? '',
                  validation: true,
                },
                employer_name: {
                  value: gData.employement_details?.employer_name ?? '',
                  validation: true,
                },
                employer_address: {
                  value: gData.employement_details?.employer_address ?? '',
                  validation: true,
                },
                employer_postal_code: {
                  value: gData.employement_details?.employer_postal_code ?? '',
                  validation: true,
                },
                employer_previous_occupation: {
                  value: gData.employement_details?.employer_previous_occupation ?? '',
                  validation: true,
                },
                employer_previous_name: {
                  value: gData.employement_details?.employer_previous_name ?? '',
                  validation: true,
                },
                employer_previous_experience_years: {
                  value:
                    gData.employement_details?.employer_previous_experience_years ?? '',
                  validation: true,
                },
                employer_previous_experience_months: {
                  value:
                    gData.employement_details?.employer_previous_experience_months ?? '',
                  validation: true,
                },
                employer_previous_address: {
                  value: gData.employement_details?.employer_previous_address ?? '',
                  validation: true,
                },
                employer_previous_postal_code: {
                  value: gData.employement_details?.employer_previous_postal_code ?? '',
                  validation: true,
                },
              };

              localStorage.setItem(
                `guarantor_employement_details_${idx + 1}`,
                JSON.stringify(g_emp_details)
              );
            }
          }

          if (gData.guarantor_type == 'company' && gData.personal_details !== null &&
            gData.personal_details !== undefined) {
            // console.log("gData============",gData.personal_details.name)
            const g_personal_details = {
              company_name: {
                value: gData?.personal_details?.company_name,
                validation: true,
              },
              contact_person: {
                value: gData?.personal_details?.name,
                validation: true,
              },
              uen_acra_no: {
                value: gData?.personal_details?.uen_acra_no,
                validation: true,
              },
              date_of_incorporation: {
                value: gData?.personal_details?.date_of_incorporation,
                validation: true,
              },
              mobile_no: {
                value: gData?.personal_details?.mobile_no,
                validation: true,
              },
              office: {
                value: gData?.personal_details?.office,
                validation: true,
              },
              email: {
                value: gData?.personal_details?.email,
                validation: true,
              },
              company_address: {
                value: gData?.personal_details?.company_address,
                validation: true,
              },
              company_postal_code: {
                value: gData?.personal_details?.company_postal_code,
                validation: true,
              },
              company_address_same_as_mailing: {
                value: gData?.personal_details?.company_address_same_as_mailing,
                validation: true,
              },
              mailing_company_address: {
                value: gData?.personal_details?.mailing_company_address,
                validation:
                  gData?.personal_details?.company_address_same_as_mailing == 0 &&
                    gData?.personal_details?.mailing_company_address === ''
                    ? false
                    : true,
              },
              mailing_company_postal_code: {
                value: gData?.personal_details?.mailing_company_postal_code,
                validation:
                  gData?.personal_details?.company_address_same_as_mailing == 0 &&
                    gData?.personal_details?.mailing_company_postal_code === ''
                    ? false
                    : true,
              },
            };
            // console.log("iset data",g_personal_details)
            localStorage.setItem(`guarantor_id_${idx + 1}`, gData.id);
            localStorage.setItem(
              `guarantor_personal_details_${idx + 1}`,
              JSON.stringify(g_personal_details)
            );
            const g_docs = {
              company_acra: gData?.documents.company_acra.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              p_l_document: gData?.documents.p_l_document.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              balance_sheet: gData.documents.balance_sheet.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              bank_statement: gData.documents.bank_statement.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              additional_documents: gData.documents.additional_documents.map(
                (item) => {
                  return {
                    name: item.name,
                    value: item.value,
                  };
                }
              ),
            };
            localStorage.setItem(
              `guarantor_documents_${idx + 1}`,
              JSON.stringify(g_docs)
            );
          }
          if (gData.documents) {
            const g_sign = {
              company_stamp: {
                name: 'companyStamp',
                value: gData.documents.company_stamp,
              },
              guarantor_signature: {
                name: 'guarantorSignature',
                value: gData.documents.guarantor_signature,
              },
            };
            localStorage.setItem(
              `guarantor_sign_documents_${idx}`,
              JSON.stringify(g_sign)
            );
          }
          localStorage.setItem(
            `guarantor_details_${idx + 1}`,
            JSON.stringify(g_details)
          );
        });
      }
      if (respData?.disbursementinfo) {
        const disbDoc = respData?.disbursementinfo;
        const localData = {
          transaction_history: disbDoc.transaction_history,
          vehicle_information: disbDoc.vehicle_information,
          vehicle_acknowledgement: disbDoc.vehicle_acknowledgement,
          insurance_certificate: disbDoc.insurance_certificate,
          number_retention_letter: disbDoc.number_retention_letter,
        };
        localStorage.setItem(
          'disbursementDocuments',
          JSON.stringify(localData)
        );
      }
    }
  };

  useEffect(() => {
    applicationDetails();
    let previousTabValue = localStorage.getItem('tabValue');
    if (previousTabValue) {
      setActiveKey(previousTabValue);
    } else {
      setActiveKey('1');
    }
    if (previousTabValue == '1') {
      setFormType('loan');
    } else if (previousTabValue == '2') {
      setFormType('vehicle');
    } else if (previousTabValue == '3') {
      setFormType('applicant');
    } else if (previousTabValue == '4') {
      setFormType('guarantor');
    } else if (previousTabValue == '5') {
      setFormType('dealer');
    } else if (previousTabValue == '6') {
      setFormType('disbursement');
    }
    if (location.state?.tabId !== undefined) {
      setActiveTab(location.state?.tabId);
    }
  }, []);

  useEffect(() => {
    if (isDisbursed) {
      setActiveTab("2");
    }
  }, [isDisbursed])



  // console.log("caseDetails", isDisbursed, activeTab)
  return (
    <div className='w-full min-h-screen bg-[#F5F5F5] overflow-x-clip'>
      <div className='bg-white'>
        <Row gutter={[24, 24]} className='p-[18px_25px]'>
          <Col xs={24} sm={12} md={15} lg={15}>
            <div className='text-[18px] font-[700] bg-white flex'>
              <div
                className='mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer'
                onClick={() => navigate(-1)}
              >
                <img src='/images/left-circle.svg' alt='arrow' />
              </div>
              <p>Loan Application</p>
              <Button
                onClick={() => {
                  navigate('/case-summary');
                }}
                className='ml-5'
                type='primary'
              >
                Case Summary
              </Button>
            </div>
          </Col>
        </Row>
        <div className='app-container p-[0px_25px] flex flex-wrap items-center justify-between'>
          <Tabs
            onChange={onChange}
            defaultActiveKey={activeKey}
            activeKey={activeKey}
            items={items}
          />
          <div className='sort-container flex flex-wrap min-[768px]:text-right pb-[12px]'>
            {!isDisbursed && (
              <>
                <p className='mr-5'>
                  <span className='min-[768px]:text-[13px] max-[768px]:text-[12px] font-[700] mr-1'>
                    Publish On:
                  </span>
                  <span className='min-[768px]:text-[12px] max-[768px]:text-[13px] font-[400]'>
                    {moment(caseDetails.created_at).format('DD MMM YYYY, HH:MM')}
                  </span>
                </p>
                <p className='min-[768px]:ml-[16px]'>
                  <span className='min-[768px]:text-[13px] max-[768px]:text-[12px] font-[700] mr-1'>
                    Case Expiry:
                  </span>
                  <span className='min-[768px]:text-[12px] max-[768px]:text-[13px] font-[400]'>
                    {moment(caseDetails.expired_at).format('DD MMM YYYY, HH:MM')}
                  </span>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      {activeKey == '1' && !isDisbursed && (
        <div className='pl-[28px] border-b border-[rgba(0,0,0,0.1)]'>
          <Tabs
            className='userAccTab'
            defaultActiveKey={activeTab}
            activeKey={activeTab}
            items={[
              {
                key: '1',
                label: (
                  <div>
                    Pending{' '}
                    <span className='ml-[7px] badge rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#0660FC] text-white h-[20px] w-[30px] inline-flex items-center justify-center'>
                      {caseDetails?.pendingCount}
                    </span>
                  </div>
                ),
              },
              {
                key: '2',
                label: (
                  <div>
                    Approved{' '}
                    <span className='ml-[7px] badge approved rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#27AE60] text-white h-[20px] w-[30px] inline-flex items-center justify-center'>
                      {caseDetails?.approvedCount}
                    </span>
                  </div>
                ),
              },
              {
                key: '3',
                label: (
                  <div>
                    Counter Offer{' '}
                    <span className='ml-[7px] badge rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#0660FC] text-white h-[20px] w-[30px] inline-flex items-center justify-center'>
                      {caseDetails?.counterOfferCount}
                    </span>
                  </div>
                ),
              },
              {
                key: '4',
                label: (
                  <div>
                    Rejected{' '}
                    <span className='ml-[7px] badge rejected rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#D30000] text-white h-[20px] w-[30px] inline-flex items-center justify-center'>
                      {caseDetails?.rejectedCount}
                    </span>
                  </div>
                ),
              },
            ]}
            onChange={(k) => {
              setActiveTab(k);
              dispatch(setLoanApplicationDetailsFilter({ activeTab: k }));
            }}
          />
        </div>
      )}
      <CaseDataContext.Provider value={{ activeTab, pagePermission }}>
        <CaseTabDetails
          applTab={activeTab}
          type={formType}
          data={caseDetails}
          reloadData={applicationDetails}
          pagePermission={pagePermission}
        />
      </CaseDataContext.Provider>
    </div>
  );
};

export default CaseDetails;
